module.exports = __webpack_public_path__ + "img/1b1c6ee.png";